import tinycolor from 'tinycolor2';

export const getContrastedColor = (hex, contrast = 60) =>
  tinycolor(hex).isLight() ? tinycolor(hex).darken(contrast).toString() : tinycolor(hex).lighten(contrast).toString();
